import { createFileRoute } from '@tanstack/react-router'
import { documentSearchSchema, healthQueryOptions } from '../../src/schemas/routeSchemas'

export const Route = createFileRoute('/document')({
  validateSearch: (search) => documentSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({
    imo: search.imo,
    registNumber: search.registNumber,
  }),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(healthQueryOptions)
  },
  staticData: {
    englishAllowed: true,
    layout: 'menu',
  },
})
